import React, { useState } from "react";
import { Image, Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface recentWorkListProps {
  data: any;
  handleDelete: (id: any) => void;
  deletingId?: any;
}

const GridRecentWork: React.FC<recentWorkListProps> = ({
  data,
  handleDelete,
  deletingId,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState<any>("");

  const openModal = (imageUrl: string) => {
    setSelectedImage(imageUrl);
    setShowModal(true);
  };

  const closeModal = () => {
    setSelectedImage(null);
    setShowModal(false);
  };
const {t} = useTranslation()

  const parseImages = (value: any) => {
    try {
      const parsed = typeof value === "string" ? JSON.parse(value) : value;
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  return (
    <div className="recent-work-grid">
      {data.length === 0 && (
        <div className="recent-work-empty">
          <div className="recent-work-empty-icon">
            <i className="bi bi-images"></i>
          </div>
          <h6>{t("No recent work yet")}</h6>
          <p>{t("Add completed projects so homeowners can review your experience.")}</p>
        </div>
      )}

      {data.map((item: any, index: number) => {
        const images = parseImages(item.rw_images);
        const coverImage = images[0];
        const isDeleting = deletingId === item.rw_id;

        return (
          <article className={`recent-work-card ${isDeleting ? "is-deleting" : ""}`} key={item.rw_id || index}>
            <button
              type="button"
              className="recent-work-cover"
              onClick={() => coverImage && openModal(coverImage)}
              disabled={!coverImage}
            >
              {coverImage ? (
                <img src={coverImage} alt={item.rw_name || "Recent work"} />
              ) : (
                <div className="recent-work-cover-empty">
                  <i className="bi bi-image"></i>
                  <span>{t("No images")}</span>
                </div>
              )}
              {images.length > 1 && (
                <span className="recent-work-image-count">
                  <i className="bi bi-images"></i> {images.length}
                </span>
              )}
            </button>

            <div className="recent-work-card-body">
              <div className="recent-work-card-header">
                <h6>{item.rw_name || t("Untitled work")}</h6>
                <Button
                  variant="soft-danger"
                  size="sm"
                  className="recent-work-delete-btn"
                  onClick={() => handleDelete(item.rw_id)}
                  disabled={isDeleting}
                >
                  {isDeleting ? (
                    <span className="spinner-border spinner-border-sm" role="status" />
                  ) : (
                    <i className="bi bi-trash"></i>
                  )}
                </Button>
              </div>

              <p className="recent-work-description">
                {item.rw_description || t("No description added.")}
              </p>

              <div className="recent-work-meta">
                <span>
                  <i className="bi bi-play-circle"></i>
                  {t("Started")}: {item.rw_started_at || "-"}
                </span>
                <span>
                  <i className="bi bi-check2-circle"></i>
                  {t("Completed")}: {item.rw_completed_at || "-"}
                </span>
              </div>

              {images.length > 1 && (
                <div className="recent-work-thumbs">
                  {images.slice(0, 4).map((image: string, imgIndex: number) => (
                    <button
                      type="button"
                      key={`${image}-${imgIndex}`}
                      onClick={() => openModal(image)}
                    >
                      <img src={image} alt={`Recent work ${imgIndex + 1}`} />
                    </button>
                  ))}
                </div>
              )}
            </div>

            {isDeleting && (
              <div className="recent-work-deleting-overlay">
                <span className="spinner-border spinner-border-sm" role="status" />
                <span>{t("Deleting...")}</span>
              </div>
            )}
          </article>
        );
      })}

      {/* Modal for displaying larger images */}
      <Modal show={showModal} onHide={closeModal} centered>
        <Modal.Body className="text-center">
          <Image
            src={selectedImage}
            alt="Selected Image"
            className="img-fluid"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            {t("Close")}
            
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default GridRecentWork;
